import React from 'react';

class Dot extends React.Component {
    static get status() {
        return {
            POSITIVE: 'POSITIVE',
            WARNING: 'WARNING',
            ERROR: 'ERROR',
            PENDING: 'PENDING'
        }
    }

    render () {
        const statusKey = (this.props.status + '').toLowerCase();
        let statusClass = 'dot-' + statusKey;
        if (statusKey === Dot.status.PENDING.toLowerCase()) {
            statusClass = 'icon-pending';
        }

        return (
            <span className={['component-dot', this.props.className, statusClass].join(' ')}></span>
        )
    }
}

export default Dot;



// WEBPACK FOOTER //
// ./web-app/components/dot.jsx